import React from "react";

function BannerArea1({ children }) {
  return (
      <div>{children}</div>
  );
}

export default BannerArea1;
